import { useState, useEffect, FC } from 'react'
import { Route } from 'react-router-dom'
import styled from 'styled-components'
import { ErrorUnknownUser, ErrorMultipleUser } from './ErrorPages'
import { LoggedOutRoutes } from './routes'

export const Centered = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100vh',
})

const WaitingForLogin: FC<{ showSubHeading: boolean }> = ({ showSubHeading }) => {
  return (
    <div>
      <strong>Please wait…</strong>
      {showSubHeading && (
        <>
          <br />
          You are being logged in.
        </>
      )}
    </div>
  )
}

const SSOSuccessView = () => {
  const [ssoError, setSsoError] = useState<string | null>(null)

  useEffect(() => {
    // expected URL /login-sso?type=error&message=_message_&usernameFromSaml=_username_
    if (window.location.search.startsWith('?type=error')) {
      const params = new URLSearchParams(window.location.search)
      const message = params.get('message')
      setSsoError(message || '')
    }
  }, [])

  const WaitingForLoginOrErrorLogin = () => {
    // When the "user" has not yet been set in the AuthContext (see useEffect in AuthProviderComponent)
    if (ssoError === null) {
      return <WaitingForLogin showSubHeading />
    } else if (ssoError === 'many.employees.for.username') {
      return <ErrorMultipleUser />
    } else if (ssoError === 'no.matching.user.found') {
      return <ErrorUnknownUser />
    } else {
      return (
        <div>
          <strong>Login via Reply Single Sign On Failed.</strong>
          <br />
          <br />
          Please <a href={LoggedOutRoutes.sso_init_route}>retry to login</a>
          <br />
          <br />
          <em style={{ fontSize: '11px' }}>{ssoError && <>{ssoError}</>}</em>
        </div>
      )
    }
  }

  return <WaitingForLoginOrErrorLogin />
}

interface UnauthenticatedAppProps {
  onRedirect: (pathName: string) => React.ReactNode
}
const UnauthenticatedApp: FC<UnauthenticatedAppProps> = ({ onRedirect }) => {
  // Set a minimal delay to wait for user context to be loaded, to prevent early redirection
  const [doInitSSOLogin, setDoInitSSOLogin] = useState<boolean>(false)

  useEffect(() => {
    /* THIS AVOIDS REACT ERRORS LIKE "SET STATE ON UNMOUNTED COMPONENT" */
    // Why useEffect? Otherwise we interrupt the render-function midways
    // Why window.location.href? Because we need a real browser redirect
    if (doInitSSOLogin === true) {
      window.location.href = LoggedOutRoutes.sso_init_route
    }
  }, [doInitSSOLogin])

  return (
    <Centered>
      <Route
        exact={false}
        path="/"
        render={(route) => {
          // We do this to "catch-all" url and redirect to login
          if (route.location.pathname === LoggedOutRoutes.home) {
            setDoInitSSOLogin(true) // NOTE: we (mis)use a state to async redirect to backend
            // WHY? Because all this router-foo are no real redirects
            //      we need a real browser-redirect to backend (see useEffect)
            return <WaitingForLogin showSubHeading={false} />
          } else if (route.location.pathname.startsWith(LoggedOutRoutes.sso_success_route)) {
            return <SSOSuccessView />
          } else {
            return onRedirect(!!route.location.hash ? route.location.pathname + route.location.hash : route.location.pathname)
          }
        }}
      />
    </Centered>
  )
}

export { UnauthenticatedApp }
